var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJpg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-837 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(837 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805.496 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M238.237,250.539a2.788,2.788,0,0,0-.679.065v2.146a2.514,2.514,0,0,0,.55.043c.874,0,1.414-.443,1.414-1.186C239.522,250.938,239.057,250.539,238.237,250.539Z",
    transform: "translate(-196.765 -239.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.1,8.882h-.6V6a.419.419,0,0,0-.005-.054.478.478,0,0,0-.115-.315L46.6.167l0,0a.483.483,0,0,0-.1-.081L46.465.063a.5.5,0,0,0-.1-.04L46.343.014A.486.486,0,0,0,46.231,0H34.466a.975.975,0,0,0-.974.974V8.881h-.6A1.392,1.392,0,0,0,31.5,10.273V17.51A1.392,1.392,0,0,0,32.9,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.532a.975.975,0,0,0,.974-.974V18.9h.6a1.392,1.392,0,0,0,1.392-1.392V10.273A1.392,1.392,0,0,0,52.1,8.882ZM34.466.974H45.744V5.956a.487.487,0,0,0,.487.487h4.3V8.882H34.466Zm9.919,11.345a2.326,2.326,0,0,1-.668,1.726,3.372,3.372,0,0,1-2.362.765,4.131,4.131,0,0,1-.561-.032v2.6H39.164V10.205a13.4,13.4,0,0,1,2.222-.151,3.489,3.489,0,0,1,2.223.583A2.126,2.126,0,0,1,44.385,12.319ZM34.007,17.324,34.191,16a2.7,2.7,0,0,0,.841.13c.691,0,1.122-.313,1.122-1.446V10.108h1.639v4.6c0,2.071-.993,2.794-2.589,2.794A4.256,4.256,0,0,1,34.007,17.324Zm16.525,6.268H34.466V18.9H50.532v4.691Zm.973-6.549a8.135,8.135,0,0,1-2.428.41,4.051,4.051,0,0,1-2.955-.982A3.515,3.515,0,0,1,45.1,13.83c.01-2.416,1.769-3.8,4.153-3.8a5,5,0,0,1,2.017.356L50.923,11.7a4.031,4.031,0,0,0-1.694-.313,2.2,2.2,0,0,0-2.4,2.352,2.38,2.38,0,0,0,3.1,2.276V14.5H48.8V13.215h2.708v3.83Z",
    transform: "translate(0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.f39b92ca6740649a83dfd43b176871f4.svg";
export { ForwardRef as ReactComponent };